import { Input, Pipe, PipeTransform } from '@angular/core';
import { User } from 'src/app/entities/user.entity';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'avatarSrc'
})
export class AvatarSrcPipe implements PipeTransform {

  @Input() ObjectKey: string = 'avatar';
  transform(user: User | any): string {
    return user.avatar ? `http${environment.API_SSL ? 's' : ''}://${environment.API_HOST_NAME}${environment.PORT ? ':' + environment.PORT : ''}/${environment.STORAGE_ENDPOINT}/${user[this.ObjectKey]}` : 'assets/img/user-avatar.png';
  }

}
